module.exports = __webpack_public_path__ + "static/img/freshman-blocky__en.20d99e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshman-blocky__en.png
// module id = SqYb
// module chunks = 1